module.exports = __webpack_public_path__ + "img/Infografis_ID_22.dcf4b493.jpg";